import { h, Fragment } from 'preact'
import { LocalizedName } from '../../../domain'
import { useLocalizedValue } from '../../../../lib/intl/IntlProvider'

type Props = {
  kortNavn: string
  navn: LocalizedName
}

export function Partinavn(props: Props) {
  const { kortNavn, navn } = props
  const localize = useLocalizedValue()
  return (
    <Fragment>
      <span aria-hidden="true">{kortNavn}</span>
      <span class="nrk-sr">{localize(navn)}</span>
    </Fragment>
  )
}
